import { TransportType } from "@syla/shared/types/helpers/TransportType";
import { UpdateTransactionRequestBody } from "@syla/shared/types/requests/TransactionRequests";
import { TransactionEvent } from "@syla/shared/types/responses/TransactionEvent";
import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";
import { parseTransactionResponseItem } from "../order/parseTransactionResponseItem";

export interface UpdateTransaction {
  accountId: string;
  id: string;
  updates: UpdateTransactionRequestBody;
}

export async function updateTransaction({
  accountId,
  id,
  updates,
}: UpdateTransaction): Promise<TransactionEvent> {
  try {
    const { data }: { data: TransportType<TransactionEvent> } =
      await axios.patch(`/accounts/${accountId}/transactions/${id}`, updates);
    return parseTransactionResponseItem(data);
  } catch (error) {
    throwSylaApiError(error);
  }
}
